/**
 * Sample output: 6-21-1990
 */

export const DASHED_DATE_FORMAT = 'd-L-y';

/**
 * Sample output: 6/21/1990
 */
export const ABBR_DATE_FORMAT = 'D';
/**
 * Sample output: Aug 6, 2014
 */
export const SHORT_FORM_DATE = 'DD';
/**
 * Sample output: August 6, 2014
 */
export const LONG_FORM_DATE = 'DDD';

export const DAYS_HOURS_MINUTES_HUMAN_FORMAT = "d 'days' h 'hours' m 'minutes'";

export const DAYS_HOURS_HUMAN_FORMAT = "d 'days' h 'hours'";

export const WEEKS_DAYS_HOURS_HUMAN_FORMAT = "w 'weeks' d 'days' h 'hours' m 'minutes'";

export const WEEKS_DAYS_HUMAN_FORMAT = "w 'weeks' d 'days'";

export const HOURS_MINUTES_HUMAN_FORMAT = "h 'hours' m 'minutes'";

export const MINUTES_SECONDS_HUMAN_FORMAT = "m' minutes 's' seconds'";
/**
 * Sample output: 1h 23m 45s
 */
export const HOURS_ELAPSED_FORMAT = "h'h' m'm' s's'";
/**
 * Sample output: 1m 23s
 */
export const MINUTES_SECONDS_ELAPSED_FORMAT = "m'm' s's'";
/**
 * Sample output: 23s
 */
export const SECONDS_ELAPSED_FORMAT = "s's'";

/**
 * Sample output: 1.234 seconds
 */
export const SECONDS_MILLISECONDS_ELAPSED_FORMAT = "s'.'S' s'";

export const MILLISECONDS_ELAPSED_FORMAT = "S' ms'";
/**
 * Sample output: PST
 */
export const TIMEZONE_NAME_ABBREVIATED = 'ZZZZ';

/**
 * Sample output: Jan 1, 2019 1:23 AM
 */
export const DATE_AND_TIME_FORMAT = 'MMM d, yyyy h:mm a';

/**
 * Sample output: Jan 1, 2019 1:23:13 AM
 */
export const DATE_AND_TIME_SECONDS_FORMAT = 'MMM d, yyyy h:mm:ss a';

/**
 * Sample output: Jan 1, 2019 1:23:13.123 AM
 */
export const DATE_AND_TIME_MILLIS_FORMAT = 'MMM d yyyy h:mm:ss.SSS a';
/**
 * Sample output: 1:07:04
 */
export const SHORT_TIME_FORMAT = 't';

/**
 * Sample output: Aug 24
 */
export const MONTH_AND_DAY = 'MMM dd';

/**
 * Sample output: 1:07:04 PM
 */
export const TIME_FORMAT = 'tt';

/**
 * Sample output: 1:07 PM
 */
export const TIME_FORMAT_NO_SECONDS = 't';

/**
 * Sample output: Jan 1, 2019 1:23 AM PDT
 */
export const DATE_AND_TIME_TZ_FORMAT = 'MMM d, yyyy h:mm a ZZZZ';

export const DATE_AND_TIME_SECONDS_TZ_FORMAT = 'MMM d, yyyy h:mm:ss a ZZZZ';

export const DATE_AND_TIME_NO_YEAR_TZ_FORMAT = 'MMM d h:mm a ZZZZ';

export type LuxonFormats =
  | typeof HOURS_ELAPSED_FORMAT
  | typeof MINUTES_SECONDS_ELAPSED_FORMAT
  | typeof TIME_FORMAT
  | typeof DATE_AND_TIME_FORMAT
  | typeof DATE_AND_TIME_TZ_FORMAT;
